module.exports = __webpack_public_path__ + "img/custom-reminder.e35c68a4.svg";